import { FeaturedIcon } from '@/lib/Icons/FeaturedIcon';
import { TranslationKeys } from '@/localization';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type HomeDataSectionHeaderProps = {
  icon: ReactNode;
  title: TranslationKeys;
  className?: string;
};

export const HomeDataSectionHeader: FC<HomeDataSectionHeaderProps> = ({ icon, title, className }) => {
  const { t } = useTranslation();

  return (
    <header className={twMerge('flex items-center gap-3', className)}>
      <FeaturedIcon size='lg'>{icon}</FeaturedIcon>
      <h3 className='font-semibold capitalize text-primary-900'>{t(title as any)}</h3>
    </header>
  );
};
